module.exports = __webpack_public_path__ + "static/media/trending3.37ca7337.png";